<template>
  <div :class="`vue-layers-container ${classes || ''}`">
    <vl-map :load-tiles-while-animating="true" 
            :load-tiles-while-interacting="true"
            @click="mapClickHandler"
            :class="mapClasses"
            :data-projection="dataProjectionType">
      <vl-view :zoom.sync="zoom" 
               :center.sync="center"
               :rotation.sync="rotation"></vl-view>

      <vl-layer-tile id="osm">
        <vl-source-osm />
      </vl-layer-tile>

      <vl-overlay v-if="solutionCoordinates" id="overlay" :position="solutionCoordinates">
        <template slot-scope="scope">
          <div class="solution">
            <i class="fas fa-map-marker-alt"></i>
          </div>
        </template>
      </vl-overlay>
      <vl-overlay v-if="userAnswerCoordinates" id="overlay2" :position="userAnswerCoordinates">
        <template slot-scope="scope">
          <div class="user-answer">
            <i class="fas fa-map-pin"></i>
          </div>
        </template>
      </vl-overlay>
    </vl-map>
  </div>
</template>

<script>
  import './VueLayersMap.scss';

  export default {
    props: { 
      classes: String, 
      mapClasses: String, 
      center: Array,
      solutionCoordinates: {
        type: Array,
        default: undefined
      },
      userAnswerCoordinates: {
        type: Array,
        default: undefined
      },
    },
    data () {
      return {
        dataProjectionType: 'EPSG:4326',
        zoom: 2,
        rotation: 0,
        geolocPosition: undefined,
        drawnFeatures: []
      }
    },
    methods: {
      mapClickHandler(event) {
        this.$emit('coordinateChange', {
          dataProjectionType: this.dataProjectionType, 
          coordinate: event.coordinate
        });
      }
    },
    watch: {
      drawnFeatures: function() {
        console.log(this.drawnFeatures);
        if (this.drawnFeatures.length > 1) {
          this.drawnFeatures = [this.drawnFeatures.pop()];
        }
      }
    }
  };
</script>
